import React from "react";
import {Heading} from "@/components/ui/heading";
import AffilateProgramElements from "@/components/affilateProgramElements";
import {Link, useNavigate} from "react-router-dom";
import Paths from "../../constants/Paths";

const AffiliateProgram = () => {
    const navigate = useNavigate();

    return (
        <section id="section-affiliate-program" className="dark-bg-with-gradients py-14">
            <div className="generic-container">
                <Heading level={2}>
                    Locked Trade Affiliate Program
                </Heading>
                <AffilateProgramElements/>
                <div className={`text-center`}>
                    <Link to={Paths.AFFILIATE_PROGRAM} className="big-button white-variant mx-auto mt-14">More informations</Link>
                </div>
            </div>
        </section>
    )
}

export default AffiliateProgram;